import React from 'react';

const ToggleCarat = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="23.5" y="0.5" width="23" height="23" rx="11.5" transform="rotate(90 23.5 0.5)" stroke="white" />
        <path d="M8.5575 14.25L12 10.5415L15.4425 14.25L16.5 13.1083L12 8.25L7.5 13.1083L8.5575 14.25Z" fill="white" />
    </svg>
);

export default ToggleCarat;
